// @flow
import * as React from 'react';
import { isEmpty } from 'lodash';
import cableAndFiberMessages from 'esm-web-pro/messages/cableAndFiberMessages';
import { FieldWrapper } from 'speed-js-react-web';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import BaseSelect from 'esm-web-pro/components/forms/fields/BaseSelect';

type Props = {
    cables: Array<Object>,
    onChange: Function,
    value: string,
    intl: IntlShape,
};

const CableWithFreeFibersSelect = (props: Props) => {
    const {
        cables, onChange, value, intl: { formatMessage },
    } = props;

    const cableChoices = cables.reduce((choices, c) => {
        if (!isEmpty(c.free_fibers)) {
            choices[c.uuid] = `${formatMessage(
                c.patch ? cableAndFiberMessages.patchCableLong : cableAndFiberMessages.cableLong,
            )} ${c.sequence} (${c.fiber_count}, 
                ${formatMessage(cableAndFiberMessages.cableLength, { length: c.reserve })})`;
        }
        return choices;
    }, {});

    return (
        <FieldWrapper
            label={(
                <FormattedMessage
                    id="splicefiberfrom-secondcableselect-title"
                    defaultMessage="Cable"
                />
            )}
            required
        >
            <BaseSelect
                emptyLabel={(
                    <FormattedMessage
                        id="splicefiberfrom-secondcableselect-select"
                        defaultMessage="Select cable"
                    />
                )}
                choices={cableChoices}
                value={value || null}
                onChange={(choice) => {
                    onChange(choice);
                }}
            />
        </FieldWrapper>
    );
};

export default injectIntl(CableWithFreeFibersSelect);
